import { createAction, handleActions } from "redux-actions";
import * as R from "ramda";
import moment from "moment";

export const types = {
  getDashboard: "DASHBOARD_GET",
  getDashboardDone: "DASHBOARD_GET_DONE",
  getNews: "DASHBOARD_GET_NEWS",
  getNewsDone: "DASHBOARD_GET_NEWS_DONE",
  setDates: "DASHBOARD_SET_DATES",
  sortByType: "POPULAR_GRIPS_SORT_BY_TYPE",
  sortBySize: "POPULAR_GRIPS_SORT_BY_SIZE",
  sortByClients: "POPULAR_GRIPS_SORT_BY_CLIENTS",
  sortByName: "POPULAR_BALL_SORT_BY_NAME",
  sortByWeight: "POPULAR_BALL_SORT_BY_WEIGHT",
  sortByBalls: "POPULAR_BALL_SORT_BY_BALLS",
  getJobBoardDashboard: "JOB_BOARD_DASHBOARD_GET",
  getJobBoardDashboardDone: "JOB_BOARD_DASHBOARD_GET_DONE",
  setJobBoardDashboardFilters: "DASHBOARD_SET_JOB_BOARD_DASHBOARD_FILTERS",
  getVideos: "DASHBOARD_GET_VIDEOS",
  getVideosDone: "DASHBOARD_GET_VIDEOS_DONE",
};

export const getDashboard = createAction(types.getDashboard);
export const getDashboardDone = createAction(types.getDashboardDone);
export const getNews = createAction(types.getNews);
export const getNewsDone = createAction(types.getNewsDone);
export const setDates = createAction(types.setDates);
export const sortByType = createAction(types.sortByType);
export const sortBySize = createAction(types.sortBySize);
export const sortByClients = createAction(types.sortByClients);
export const sortByName = createAction(types.sortByName);
export const sortByWeight = createAction(types.sortByWeight);
export const sortByBalls = createAction(types.sortByBalls);
export const getJobBoardDashboard = createAction(types.getJobBoardDashboard);
export const getJobBoardDashboardDone = createAction(
  types.getJobBoardDashboardDone
);
export const setJobBoardDashboardFilters = createAction(
  types.setJobBoardDashboardFilters
);
export const getVideos = createAction(types.getVideos);
export const getVideosDone = createAction(types.getVideosDone);

const startingDate = moment().subtract(7, "days").startOf("day").toDate();

const endingDate = moment().endOf("day").toDate();

const JBstartingDate = moment().subtract(100, "years").startOf("day").toDate();

const JBendingDate = moment().add(100, "years").endOf("day").toDate();

const previousStartingDate = moment()
  .subtract(15, "days")
  .startOf("day")
  .toDate();

const previousEndingDate = moment().subtract(8, "days").endOf("day").toDate();

export const INITIAL_STATE = {
  dashboard: {
    most_recent: {
      customers: [],
      specsheets: [],
    },
    range: {
      current: {
        start: startingDate,
        end: endingDate,
      },
      previous: {
        start: previousStartingDate,
        end: previousEndingDate,
      },
    },
    current_totals: {
      customers: 0,
      specsheets: 0,
      ballsDrilled: 0,
    },
    previous_totals: {
      customers: 0,
      specsheets: 0,
      ballsDrilled: 0,
    },
    popular_grips: [],
    popular_balls: [],
    charts: {
      byHand: [],
      byStyle: [],
    },
  },
  loadingDashboard: false,
  loadingNews: false,
  loadingVideos: false,
  news: null,
  videos: null,
  loadingJobBoardDashboard: false,
  startingDate,
  endingDate,
  previousStartingDate,
  previousEndingDate,
  popularGripsSort: {
    type: 0,
    size: 0,
    clients: -1,
  },
  popularBallSort: {
    name: 0,
    weight: 0,
    balls: -1,
  },
  jobBoardDashboardFilters: {
    startingDate: JBstartingDate,
    endingDate: JBendingDate,
    status: "pending,late,waiting_pickup",
    salesPerson: "",
    jobLocation: "",
    jobService: "",
  },
  job_board_dashboard: [],
};

export const dashboardReducer = handleActions(
  {
    [types.getDashboard]: (state) => {
      return {
        ...state,
        loadingDashboard: true,
      };
    },
    [types.getNews]: (state) => {
      return {
        ...state,
        loadingNews: true,
      };
    },
    [types.setDates]: (state, action) => {
      return {
        ...state,
        startingDate: action.payload.startingDate,
        endingDate: action.payload.endingDate,
        previousStartingDate: action.payload.previousStartingDate,
        previousEndingDate: action.payload.previousEndingDate,
      };
    },
    [types.getDashboardDone]: (state, action) => ({
      ...state,
      dashboard: {
        ...action.payload.dashboard,
        popular_grips: action.payload.dashboard.popular_grips?.filter(
          (grip) => grip.grip_type || ("" !== "" && grip.size) || "" !== ""
        ),
        popular_balls: action.payload.dashboard.popular_balls?.filter(
          (ball) => ball.ball_name || ("" !== "" && ball.weight) || "" !== ""
        ),
      },
      loadingDashboard: false,
    }),
    [types.getNewsDone]: (state, action) => ({
      ...state,
      news: action.payload.news,
      loadingNews: false,
    }),
    [types.sortByType]: (state, action) => ({
      ...state,
      popularGripsSort: {
        type: action.payload?.sort,
        size: 0,
        clients: 0,
      },
    }),
    [types.sortBySize]: (state, action) => ({
      ...state,
      popularGripsSort: {
        type: 0,
        size: action.payload?.sort,
        clients: 0,
      },
    }),
    [types.sortByClients]: (state, action) => ({
      ...state,
      popularGripsSort: {
        type: 0,
        size: 0,
        clients: action.payload?.sort,
      },
    }),
    [types.sortByName]: (state, action) => ({
      ...state,
      popularBallSort: {
        name: action.payload?.sort,
        weight: 0,
        balls: 0,
      },
    }),
    [types.sortByWeight]: (state, action) => ({
      ...state,
      popularBallSort: {
        name: 0,
        weight: action.payload.sort,
        balls: 0,
      },
    }),
    [types.sortByBalls]: (state, action) => ({
      ...state,
      popularBallSort: {
        name: 0,
        weight: 0,
        balls: action.payload?.sort,
      },
    }),
    [types.getJobBoardDashboard]: (state) => {
      return {
        ...state,
        loadingJobBoardDashboard: true,
      };
    },
    [types.getJobBoardDashboardDone]: (state, action) => ({
      ...state,
      job_board_dashboard: action.payload?.job_board_dashboard,
      loadingJobBoardDashboard: false,
    }),
    [types.setJobBoardDashboardFilters]: (state, action) => ({
      ...state,
      jobBoardDashboardFilters: {
        ...state.jobBoardDashboardFilters,
        ...action.payload,
      },
    }),
    [types.getVideos]: (state) => ({
      ...state,
      loadingVideos: true,
    }),
    [types.getVideosDone]: (state, action) => ({
      ...state,
      videos: action.payload?.videos,
      loadingVideos: false,
    }),
  },
  INITIAL_STATE
);
